if (!customElements.get('awards-timeline-slider')) {
  class AwardsTimelineSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-timeline-track]');
      if (!this.track) return;

      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
    }

    connectedCallback() {
      if (!this.track) return;
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointerleave', this.onPointerUp);
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('pointerdown', this.onPointerDown);
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.track.removeEventListener('pointerup', this.onPointerUp);
      this.track.removeEventListener('pointerleave', this.onPointerUp);
    }

    onPointerDown(event) {
      if (event.pointerType === 'touch') return;
      this.isDown = true;
      this.track.classList.add('is-dragging');
      this.startX = event.pageX - this.track.offsetLeft;
      this.scrollLeft = this.track.scrollLeft;
      this.track.setPointerCapture(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.isDown) return;
      event.preventDefault();
      var x = event.pageX - this.track.offsetLeft;
      var walk = (x - this.startX) * 1.2;
      this.track.scrollLeft = this.scrollLeft - walk;
    }

    onPointerUp() {
      this.isDown = false;
      this.track.classList.remove('is-dragging');
    }
  }

  customElements.define('awards-timeline-slider', AwardsTimelineSlider);
}
